exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--1le1lL6y87ScmXHeFdCWnl {\n  border: none;\n}\n\n.auto-dialer--xVjhpNANUHetS5WMGJA3h {\n  position: absolute;\n  top: 5px;\n  right: 26px;\n  margin: 0 !important;\n  width: 40px !important;\n  height: 25px !important;\n  margin: 0 !important;\n}\n", ""]);

// exports
exports.locals = {
	"bars": "auto-dialer--1le1lL6y87ScmXHeFdCWnl",
	"bars": "auto-dialer--1le1lL6y87ScmXHeFdCWnl",
	"barsContainer": "auto-dialer--xVjhpNANUHetS5WMGJA3h",
	"barsContainer": "auto-dialer--xVjhpNANUHetS5WMGJA3h"
};